import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';

import { includes } from 'lodash';

import { defaultAngularJsRoutes } from '../ajs-app/app-routing.module.ajs';
import { App404Component } from './core/error-pages/app404/app404.component';

// https://angular.io/guide/upgrade#configure-a-custom-route-matcher-for-angularjs-routes
export function isAngularJSUrl(url: UrlSegment[]) {
    const isRegisteredInNav = includes(defaultAngularJsRoutes, url[0].path);
    return url.length > 0 && isRegisteredInNav ? ({ consumed: url }) : null;
}

const routes: Routes = [
    {
        path: '',
        redirectTo: 'authentication/login',
        pathMatch: 'full'
    },
    /**
     * Lazy load AngularJS module here
     */
    {
        matcher: isAngularJSUrl,
        loadChildren: () => import('./ng1-wrapper.module').then(mod => mod.Ng1WrapperModule)
    },
    {
        path: 'error',
        loadChildren: () => import('./core/error-pages/error-pages.module').then(module => module.ErrorPagesModule)
    },
    {
        path: '**',
        component: App404Component
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        useHash: false,
        initialNavigation: 'enabledNonBlocking', // 'enabledNonBlocking' is the same as 'true' in Angular 10
        onSameUrlNavigation: 'reload'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
